import { z } from "zod";

export const ValidationSchema = z.object({
  admitcardnumber: z
    .string()
    .min(3, { message: "Admit Card Number is required." }),
});
